import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserResolverService } from '../services/user-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class AsmInternalGuard {
  private _userResolverService = inject(UserResolverService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._userResolverService.userInfo.pipe(
      take(1),
      map(userInfo => userInfo?.IsASM ?? false)
    );
  }
}

